import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GithubService {

  URLbase: string = "https://api.github.com/";

  constructor(private http: HttpClient) { }

  public getRepos(username: string): Observable<any> {

    return this.http.get(this.URLbase + 'users/' + username + '/repos',)
    .pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse){
    if (error.status === 0) {
      // Ocurrió un error del lado del cliente. Manejarlo de acuerdo 
      console.error('An error has occurred', error.error);
    } else {
      // El backend retornó un codigo de respuesta no exitoso
      // El cuerpo del response puede contener pistas de lo que puede estar malo.
      console.error(
        `Backend return a code ${error.status}, ` +
        `Body was: ${error.error}`
      );
    }
    // Retorna un observable con un mensaje para el usuario
    return throwError(
      'Somenthing went wrong: try with another username.'
    );
  }
}
